module.exports = __webpack_public_path__ + "img/block2.fc4ece9a.svg";